
/**
 * APP 环境存储unpl
 */

import { callKNBBridge, callGrowthMSIBridge, BridgeType, callMSIBridge, getBridgeType, callKNBUseBridge } from "./base";
import { reportCustomMetric } from '@/lib/owl';
import { logInfo, reportLog } from '../logan';

/* ----- MSI.setStorage 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?tab=C&id=1351
/* ----- MSI.setStorage 类型声明 end ----- */

/**
 * 自定义打点是否存储成功
 */
const reportSetUnplSuccess = (value: number) => {
  reportCustomMetric({
    key: "setAppUnpl",
    value
  });
}

/**
 * 存储 UNPL 到 Bridge
 * @param unpl - UNPL 值
 * @param reportUnplError - 错误上报方法
 */
export const setUnplToBridge = (unpl: string, reportUnplError: Function): void => {
  const bridgeType = getBridgeType();

  switch (bridgeType) {
    case BridgeType.KNB:
      callKNBUseBridge('waimai.setUnpl', {
        unpl: unpl || '',
        // 桥方法没有回调
      });
      callKNBBridge('setStorage', {
        key: 'unpl',
        value: unpl || '', // 数据值，String类型
        level: 1, // 存储级别，Interger类型，0 - 内存【默认】，1 - 设备，2 - 云端【11】
        success: () => {
          logInfo('[setAppUnpl] setStorage success');
          reportSetUnplSuccess(1);
        },
        fail: (error: Error) => {
          reportSetUnplSuccess(0);
          reportUnplError('[setUnplStorage] knbsetStorage error', error, 'bridgeError');
          logInfo('[setAppUnpl] setStorage fail');
        },
      });
      break;
    case BridgeType.MSI:
      callMSIBridge('setSharedStorage', {
        key: 'unpl',
        data: unpl || '', // 数据值，String类型
        channel: 'waimai_takeout',
        level: 0, // 存储级别，Interger类型，0-设备，1 - App内存
        success: () => {
          logInfo('[setAppUnpl] setSharedStorage msi waimai_takeout success');
          reportSetUnplSuccess(1);
        },
        fail: (error: Error) => {
          reportSetUnplSuccess(0);
          logInfo('[setAppUnpl] setSharedStorage msi waimai_takeout fail');
          reportUnplError('[setUnplStorage] misSetStorage waimai_takeout error', error, 'bridgeError');
        },
      });
      callMSIBridge('setSharedStorage', {
        key: 'unpl',
        data: unpl || '', // 数据值，String类型
        level: 0, // 存储级别，Interger类型，0-设备，1 - App内存
        success: () => {
          logInfo('[setAppUnpl] setSharedStorage msi success');
          reportSetUnplSuccess(1);
        },
        fail: (error: Error) => {
          reportSetUnplSuccess(0);
          logInfo('[setAppUnpl] setSharedStorage msi fail');
          reportUnplError('[setUnplStorage] misSetStorage error', error, 'bridgeError');
        },
      });
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("setSharedStorage", {
        key: 'unpl',
        data: unpl || '',
        channel: 'waimai_takeout',
        success: () => {
          logInfo('[setAppUnpl] setSharedStorage growth waimai_takeout success');
          reportSetUnplSuccess(1);
        },
        fail: (error: Error) => {
          reportSetUnplSuccess(0);
          logInfo('[setAppUnpl] setSharedStorage growth waimai_takeout fail');
          reportUnplError('[setUnplStorage] growth waimai_takeout setStorage error', error, 'bridgeError');
        },
      });
      callGrowthMSIBridge("setSharedStorage", {
        key: 'unpl',
        data: unpl || '',
        level: 0, // 存储级别，Interger类型，0-设备，1 - App内存
        success: () => {
          logInfo('[setAppUnpl] setSharedStorage growth success');
          reportSetUnplSuccess(1);
        },
        fail: (error: Error) => {
          reportSetUnplSuccess(0);
          logInfo('[setAppUnpl] setSharedStorage growth fail');
          reportUnplError('[setUnplStorage] growth setStorage error', error, 'bridgeError');
        },
      });
      break;
    default:
      break;
  }

  setTimeout(() => {
    reportLog();
  }, 1000);
};
